import React, { useState, useEffect, useCallback } from 'react';
import { FileUploader, PageHeaderWithButton } from "../../Components";
import { getSettings, updateLocalCampaignBlock, updateSettings } from '../../Services/Api.service';
import { BlockPage } from '../Block/Block.page';
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from '@ckeditor/ckeditor5-editor-classic/src/classiceditor';
import FileRepository from '@ckeditor/ckeditor5-upload/src/filerepository';
import Alignment from '@ckeditor/ckeditor5-alignment/src/alignment';
import Autoformat from '@ckeditor/ckeditor5-autoformat/src/autoformat';
import AutoLink from '@ckeditor/ckeditor5-link/src/autolink';
import Base64UploadAdapter from '@ckeditor/ckeditor5-upload/src/adapters/base64uploadadapter';
import BlockQuote from '@ckeditor/ckeditor5-block-quote/src/blockquote';
import Bold from '@ckeditor/ckeditor5-basic-styles/src/bold';
import CloudServices from '@ckeditor/ckeditor5-cloud-services/src/cloudservices';
import Essentials from '@ckeditor/ckeditor5-essentials/src/essentials';
import Heading from '@ckeditor/ckeditor5-heading/src/heading';
import Image from '@ckeditor/ckeditor5-image/src/image';
import ImageCaption from '@ckeditor/ckeditor5-image/src/imagecaption';
import ImageStyle from '@ckeditor/ckeditor5-image/src/imagestyle';
import ImageToolbar from '@ckeditor/ckeditor5-image/src/imagetoolbar';
import ImageUpload from '@ckeditor/ckeditor5-image/src/imageupload';
import Indent from '@ckeditor/ckeditor5-indent/src/indent';
import Italic from '@ckeditor/ckeditor5-basic-styles/src/italic';
import Link from '@ckeditor/ckeditor5-link/src/link';
import List from '@ckeditor/ckeditor5-list/src/list';
import MediaEmbed from '@ckeditor/ckeditor5-media-embed/src/mediaembed';
import Paragraph from '@ckeditor/ckeditor5-paragraph/src/paragraph';
import PasteFromOffice from '@ckeditor/ckeditor5-paste-from-office/src/pastefromoffice';
import Table from '@ckeditor/ckeditor5-table/src/table';
import TableToolbar from '@ckeditor/ckeditor5-table/src/tabletoolbar';
import TextTransformation from '@ckeditor/ckeditor5-typing/src/texttransformation';
import { CustomPastePlainText } from '../../Components/crud-component/CRUDFormField';

import { translate } from '../../../Services/translation';

export const Settings = () => {
    const [settings, setSettings] = useState({
        storeName: '',
        description: '',
        storeWebsiteEmail: '',
        storeWebsitePhone: '',
        imageUrl: '',
        facebookLink: '',
        instagramLink: '',
        LogoImage: undefined,
        frontPageBannerTitle: '',
        frontPageBannerDescription: '',
        frontPageBannerLink1: '',
        frontPageBannerLink2: '',
        frontPageBannerLink1Text: '',
        frontPageBannerLink2Text: '',
        localCampaignDescription: '',
        pricingDetails: ''
    });
    const [convertedImageLogo, setConvertedImageLogo] = useState(null);
    const [convertedImage, setConvertedImage] = useState(null);
    const [data, setData] = useState("");
    const [pricingData, setPricingData] = useState("");

    const onChangeHandler = useCallback(
        ({ target: { name, value } }) => {
            setSettings({ ...settings, [name]: value })
        }, [settings, setSettings]);

    useEffect(() => {
        getSettings().then((data) => {
            setSettings(data);
        });
    }, [setSettings]);

    const saveSettings = () => {
        updateSettings(settings, data, pricingData).then((result) => {            
            if (result) {
                location.reload();
            }
        });
    }

    return (
        <div className="backend__settings">
            <PageHeaderWithButton title={translate('coptikk.adminportal.settings')} btnText={translate('coptikk.adminportal.savebuttontext')} btnOnClick={() => saveSettings()} />
            <div className="row">
                <div className="columns small-12">
                    <div className="settings__field">
                        <div className="row settings__inner-row">
                            <div className="columns small-12"><h5>{translate('coptikk.adminportal.abouttext')}</h5></div>
                            <div className="columns small-6">
                                <label>{translate('coptikk.adminportal.storewebsitenametext')}<input type="text" name="storeName" onChange={onChangeHandler} value={settings.storeName || ''} /></label>
                            </div>
                            <div className="columns small-6">
                                <label>{translate('coptikk.adminportal.storedescriptiontext')}<input type="text" name="description" onChange={onChangeHandler} value={settings.description || ''} /></label>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="columns small-12">
                    <div className="settings__field">
                        <div className="row settings__inner-row">
                            <div className="columns small-12"><h5>{translate('coptikk.adminportal.contacttext')}</h5></div>
                            <div className="columns small-6">
                                <label>{translate('coptikk.adminportal.emailtext')}<input type="text" name="storeWebsiteEmail" onChange={onChangeHandler} value={settings.storeWebsiteEmail || ''} /></label>
                            </div>
                            <div className="columns small-6">
                                <label>{translate('coptikk.adminportal.phonetext')}<input type="text" name="storeWebsitePhone" onChange={onChangeHandler} value={settings.storeWebsitePhone || ''} /></label>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="columns small-12">
                    <div className="settings__field">
                        <div className="row settings__inner-row">
                            <div className="columns small-12"><h5>{translate('coptikk.adminportal.socialtext')}</h5></div>
                            <div className="columns small-6">
                                <label>{translate('coptikk.adminportal.facebooktext')}<input type="text" name="facebookLink" onChange={onChangeHandler} value={settings.facebookLink || ''} /></label>
                            </div>
                            <div className="columns small-6">
                                <label>{translate('coptikk.adminportal.instagramtext')}<input type="text" name="instagramLink" onChange={onChangeHandler} value={settings.instagramLink || ''} /></label>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="columns small-12">
                    <div className="settings__field">
                        <div className="row settings__inner-row">
                            <div className="columns small-12"><h5>{translate('coptikk.adminportal.logotext')}</h5></div>
                            {!settings.imageUrl ?
                                <div className='placeholder-image'></div>
                                : ""
                            }
                            <div className="columns small-12">
                                <label><FileUploader
                                    onFileSelectSuccess={(file) => {
                                        setSettings({ ...settings, imageUrl: file });
                                        let fr = new FileReader();
                                        fr.onload = () => {
                                            setConvertedImageLogo(fr.result);
                                        };
                                        fr.readAsDataURL(file);
                                    }} /></label>
                            </div>
                            <div className="columns small-12 image-wrapper">
                                {convertedImageLogo ? <img src={convertedImageLogo} /> : settings.imageUrl && settings.imageUrl.length ? 
                                <img src={settings.imageUrl} /> : null}
                            </div>
                            <div className="columns small-6"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='settings__banner'>
                <h1 className="page__sub-title">{translate('coptikk.adminportal.frontpagebannertext')}</h1>
                <div className='settings__field'>
                    <div className="row">
                        <div className="columns small-6">
                            <label>{translate('coptikk.adminportal.frontpagebannertitletext')}<input type="text" name="frontPageBannerTitle" onChange={onChangeHandler} value={settings.frontPageBannerTitle || ''} /></label>
                        </div>                        
                    </div>
                    <div className="row">
                        <div className="columns small-6">
                            <label>{translate('coptikk.adminportal.frontpagebannerlink1text')}<input type="text" name="frontPageBannerLink1" onChange={onChangeHandler} value={settings.frontPageBannerLink1 || ''} /></label>
                        </div>
                        <div className="columns small-6">
                            <label>{translate('coptikk.adminportal.frontpagebannerlink2text')}<input type="text" name="frontPageBannerLink2" onChange={onChangeHandler} value={settings.frontPageBannerLink2 || ''} />
                            </label>
                        </div>
                    </div>
                    <div className="row">
                        <div className="columns small-6">
                            <label>{translate('coptikk.adminportal.frontpagebannerlinktext1text')}<input type="text" name="frontPageBannerLink1Text" onChange={onChangeHandler} value={settings.frontPageBannerLink1Text || ''} /></label>
                        </div>
                        <div className="columns small-6">
                            <label>{translate('coptikk.adminportal.frontpagebannerlinktext2text')}<input type="text" name="frontPageBannerLink2Text" onChange={onChangeHandler} value={settings.frontPageBannerLink2Text || ''} />
                            </label>
                        </div>
                    </div>
                    <div className="upload-image">
                        <div className="row settings__inner-row">
                            <div className="columns small-12"><h5>{translate('coptikk.adminportal.frontpagebannerimagetext')}</h5></div>
                            {!settings.frontPageBannerImageUrl ?
                                <div className='placeholder-image'></div>
                                : ""
                            }
                            <div className="columns small-12">
                                <label><FileUploader
                                    onFileSelectSuccess={(file) => {
                                        setSettings({ ...settings, frontPageBannerImageUrl: file });
                                        let fr = new FileReader();
                                        fr.onload = () => {
                                            setConvertedImage(fr.result);
                                        };
                                        fr.readAsDataURL(file);
                                    }} /></label>
                            </div>
                            <div className="columns small-12 image-wrapper">
                                {convertedImage ? <img src={convertedImage} /> : settings.frontPageBannerImageUrl && settings.frontPageBannerImageUrl.length ?
                                    <img src={settings.frontPageBannerImageUrl} /> : null}
                            </div>
                            <div className="columns small-6"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='settings__campaign'>
                <h1 className="page__sub-title">{translate('coptikk.adminportal.localcampaigntext')}</h1>
                <div className='settings__field'>
                    <div className="row">
                        <div className="columns small-6">
                            <label>{translate('coptikk.adminportal.localcampaigntitletext')}<input type="text" name="localCampaignTitle" onChange={onChangeHandler} value={settings.localCampaignTitle || ''} /></label>
                        </div>
                        <div className="columns small-6">
                            <label>{translate('coptikk.adminportal.localcampaignheadertext')}<input type="text" name="localCampaignHeader" onChange={onChangeHandler} value={settings.localCampaignHeader || ''} /></label>
                        </div>
                    </div>
                    <div className="row">
                        <div className="columns small-12">
                            <label>{translate('coptikk.adminportal.localcampaigndescriptiontext')} </label>
                            <CKEditor
                                editor={ClassicEditor}
                                data={settings.localCampaignDescription || ''}
                                className="editor"
                                disabled={false}
                                onReady={(editor) => {
                                    // You can store the "editor" and use when it is needed.
                                    editor.plugins.get("FileRepository").createUploadAdapter = (loader) => new UploadAdapter(loader);

                                }}
                                config={{
                                    toolbar: [
                                        "selectAll",
                                        "customPastePlainText",
                                        "undo",
                                        "redo",
                                        "bold",
                                        "italic",
                                        "blockQuote",
                                        "ckfinder",
                                        "imageTextAlternative",
                                        "imageUpload",
                                        "heading",
                                        "indent",
                                        "outdent",
                                        "link",
                                        "numberedList",
                                        "bulletedList",
                                        "mediaEmbed",
                                        "insertTable",
                                        "tableColumn",
                                        "tableRow",
                                        "mergeTableCells"
                                    ],
                                    image: {
                                        // Configure the available styles.
                                        styles: ["alignLeft", "alignCenter", "alignRight"],
                                        sizes: ["50%", "75%", "100%"],
                                        // You need to configure the image toolbar, too, so it shows the new style
                                        // buttons as well as the resize buttons.
                                        toolbar: [
                                            "imageStyle:alignLeft",
                                            "imageStyle:alignCenter",
                                            "imageStyle:alignRight",
                                            "|",
                                            "imageTextAlternative"
                                        ]
                                    },
                                    plugins: [
                                        FileRepository,
                                        CustomPastePlainText,
                                        Alignment,
                                        Autoformat,
                                        AutoLink,
                                        Base64UploadAdapter,
                                        BlockQuote,
                                        Bold,
                                        CloudServices,
                                        Essentials,
                                        Heading,
                                        Image,
                                        ImageCaption,
                                        ImageStyle,
                                        ImageToolbar,
                                        ImageUpload,
                                        Indent,
                                        Italic,
                                        Link,
                                        List,
                                        MediaEmbed,
                                        Paragraph,
                                        PasteFromOffice,
                                        Table,
                                        TableToolbar,
                                        TextTransformation,
                                    ]
                                }}                                  
                                onChange={(event, editor) => setData(editor.getData())}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="columns small-6">
                            <label>{translate('coptikk.adminportal.localcampaignlinktext')}<input type="text" name="localCampaignCampaignLink" onChange={onChangeHandler} value={settings.localCampaignCampaignLink || ''} /></label>
                        </div>
                        <div className="columns small-6">
                            <label>{translate('coptikk.adminportal.localcampaignlinktexttext')}<input type="text" name="localCampaignCampaignLinkText" onChange={onChangeHandler} value={settings.localCampaignCampaignLinkText || ''} /></label>
                        </div>
                    </div>
                    <div className="row">
                        <div className="columns small-6">
                            <label>{translate('coptikk.adminportal.localcampaignfromtext')}<input type="date" name="localCampaignFromDate" onChange={onChangeHandler} value={settings.localCampaignFromDate && settings.localCampaignFromDate.split('T')[0] || ''} /></label>
                        </div>
                        <div className="columns small-6">
                            <label>{translate('coptikk.adminportal.localcampaigntotext')}<input type="date" name="localCampaignToDate" onChange={onChangeHandler} value={settings.localCampaignToDate && settings.localCampaignToDate.split('T')[0] || ''} /></label>
                        </div>
                    </div>

                </div>
            </div>
            <div>
                <h1 className="page__sub-title">{translate('coptikk.adminportal.settings.pricing')}</h1>
                <div className="settings__field">
                    <div className="row">
                        <div className="columns small-12">
                            <label>{translate('coptikk.adminportal.settings.pricing')} </label>
                            <CKEditor
                                editor={ClassicEditor}
                                data={settings.pricingDetails || ''}
                                className="editor"
                                disabled={false}
                                onReady={(editor) => {
                                    // You can store the "editor" and use when it is needed.
                                    editor.plugins.get("FileRepository").createUploadAdapter = (loader) => new UploadAdapter(loader);

                                }}
                                config={{
                                    toolbar: [
                                        "selectAll",
                                        "customPastePlainText",
                                        "undo",
                                        "redo",
                                        "bold",
                                        "italic",
                                        "blockQuote",
                                        "ckfinder",
                                        "imageTextAlternative",
                                        "imageUpload",
                                        "heading",
                                        "indent",
                                        "outdent",
                                        "link",
                                        "numberedList",
                                        "bulletedList",
                                        "mediaEmbed",
                                        "insertTable",
                                        "tableColumn",
                                        "tableRow",
                                        "mergeTableCells"
                                    ],
                                    image: {
                                        // Configure the available styles.
                                        styles: ["alignLeft", "alignCenter", "alignRight"],
                                        sizes: ["50%", "75%", "100%"],
                                        // You need to configure the image toolbar, too, so it shows the new style
                                        // buttons as well as the resize buttons.
                                        toolbar: [
                                            "imageStyle:alignLeft",
                                            "imageStyle:alignCenter",
                                            "imageStyle:alignRight",
                                            "|",
                                            "imageTextAlternative"
                                        ]
                                    },
                                    plugins: [
                                        FileRepository,
                                        CustomPastePlainText,
                                        Alignment,
                                        Autoformat,
                                        AutoLink,
                                        Base64UploadAdapter,
                                        BlockQuote,
                                        Bold,
                                        CloudServices,
                                        Essentials,
                                        Heading,
                                        Image,
                                        ImageCaption,
                                        ImageStyle,
                                        ImageToolbar,
                                        ImageUpload,
                                        Indent,
                                        Italic,
                                        Link,
                                        List,
                                        MediaEmbed,
                                        Paragraph,
                                        PasteFromOffice,
                                        Table,
                                        TableToolbar,
                                        TextTransformation,
                                    ]
                                }}                                      
                                onChange={(event, editor) => setPricingData(editor.getData())}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}